module.exports = __webpack_public_path__ + "img/img47.659f855b.svg";